import type { ButtonHTMLAttributes, ReactNode } from 'react';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Square size in px. 24 = card-head variant (default), 28 = page-head variant. */
  size?: 24 | 28;
  /** Accessible label is required for icon-only buttons. */
  'aria-label': string;
  children: ReactNode;
}

/**
 * Square icon button — 24px (card-head) or 28px (page-head). Muted icon
 * color; hover swaps to `--fg-strong` on `--surface-2`. Matches dashboard.html
 * `.card-head .icon-btn` (with a larger size for page headers).
 */
export function IconButton({
  size = 24,
  className,
  children,
  type,
  ...rest
}: IconButtonProps) {
  const cls = [
    'pn-icon-btn',
    size === 28 ? 'pn-icon-btn-lg' : 'pn-icon-btn-sm',
    className
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <button type={type ?? 'button'} className={cls} {...rest}>
      {children}
    </button>
  );
}
